import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.toLowerCase().includes(searchText);
        });
    }
}

@Pipe({ name: 'searchFilter' })
export class SearchPipe implements PipeTransform {
    transform(value: any, searchValue?: any,colName?: any): any {
        if(!value) return null;
        if(!colName) return value;
        if(!searchValue) return value;
        searchValue = searchValue.toString().toLowerCase();
        return value.filter((item)=> {
            return item[colName].toString().toLowerCase().includes(searchValue) || item[colName] == searchValue;
        });
    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/filter.pipe.ts